import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from "@angular/core";

@Directive({
    selector: '[outsideClick]'
})
export class OutsideClickDirective {
    constructor(private _elementRef: ElementRef) {
    }
    @Input()
    public linkedElements: string[];
    @Input()
    public popupElement: string;
    @Output()
    public outsideClick: EventEmitter<boolean> = new EventEmitter<boolean>();

    @HostListener('document:click', ['$event', '$event.target'])
    public onClick(event: MouseEvent, targetElement: HTMLElement): void {
        let linkedEleClick;
        let popupElementClick;
        if (this.linkedElements) {
            if (this.linkedElements) {
                linkedEleClick = this.linkedElements.some((eleSelector) => {
                    const linkedEle = document.querySelector(eleSelector);
                    if (linkedEle) {
                        linkedEleClick = linkedEle.contains(targetElement);
                    }
                    return linkedEleClick;
                });
            }
        }
        if (this.popupElement) {
            popupElementClick = document.querySelector(this.popupElement);
        }
        const clickedInside = this._elementRef.nativeElement.contains(targetElement) || linkedEleClick || popupElementClick;
        if (!clickedInside) {
            this.outsideClick.emit(false);
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/customerservice/directive/outside-click.directive.ts